<template>
  <div id="app">
    <div
      id="momou"
      :class="{ browsergame: isBrowserGame, momou: !isBrowserGame }"
    >
      <Init v-if="!initiated" />
      <Install v-if="!installed && initiated" />
      <Public v-if="installed && initiated" />
      <Private />
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Private from "./components/private.vue";
import Public from "./components/public.vue";
import Install from "./components/install.vue";
import Init from "./components/init.vue";

export default {
  name: "App",
  components: {
    Public,
    Private,
    Install,
    Init,
  },
  mounted() {
    if ("install" in this.$route.query) {
      this.$store.commit("startInstall");
      this.$store.commit("setTimer", this.$route.query.install);
    }
  },
  computed: {
    ...mapGetters([
      "dialogues",
      "conditions",
      "currentDialogue",
      "anydialogue",
      "talkingTo",
      "selected",
      "installed",
      "isBrowserGame",
      "initiated",

      // ...
    ]),
  },
};
</script>

<style lang="scss">
@import "./scss/_variables.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //  text-align: center;
  background: transparent;
}
html,
body {
  background: transparent;
  margin: 0;
}
$height_m: $height-full * 2;

.momou {
  height: $height_m;
  width: $width;
  position: absolute;
  display: flex;
  flex-direction: column;
}
.browsergame {
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
}
.cover {
  position: absolute;
  height: $height;
  width: $width;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.waiting {
  height: $height-waiting;
  width: auto;
  filter: drop-shadow(3px 3px 0px rgba(0, 0, 0, 1))
    drop-shadow(-3px -3px 0px rgba(255, 255, 255, 1))
    drop-shadow(1px 5px 5px rgba(0, 0, 0, 0.55));
  /*filter: drop-shadow(4px 4px 0px rgba(229,0,126,1)) drop-shadow(-4px -4px 0px rgba(229,0,126,1)) drop-shadow(1px 3px 5px rgba(0,0,0,0.55));*/
  /*    filter: drop-shadow(1px 3px 5px rgba(0,0,0,0.55));*/
}
</style>
